import React, { useState } from 'react';
import Navbar from './Navbar';
import ScrollShowcase from './ScrollShowcase';
import SearchSection from './SearchSection';
import PopularCities from './PopularCities';
import PropertyListings from './PropertyListings';
import Testimonials from './Testimonials';
import Footer from './Footer';
import ScrollProgress from './ScrollProgress';
import AIChatbot from './AIChatbot';
import PropertyMatch from './PropertyMatch';
import VibemateUSP from './VibemateUSP';
import { Sparkles } from 'lucide-react';

const HomePage = () => {
  const [showPropertyMatch, setShowPropertyMatch] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);

  return (
    <div className="min-h-screen">
      <ScrollProgress />
      <Navbar />

      <ScrollShowcase />

      <div className="relative">
        {/* AI Property Match floating button */}
        <div className="sticky top-4 z-40 flex justify-center pointer-events-none" style={{ marginTop: '-2rem' }}>
          <button
            onClick={() => setShowPropertyMatch(true)}
            className="pointer-events-auto flex items-center gap-2 bg-gradient-135 text-white px-5 py-2.5 rounded-full shadow-lg hover:opacity-90 transition-all hover:scale-105 text-sm font-semibold"
            data-testid="property-match-btn"
          >
            <Sparkles className="w-4 h-4" />
            AI Property Match
          </button>
        </div>

        <SearchSection />
        <PopularCities onCitySelect={setSelectedCity} />

        {/* VibeMate + Rewards — combined rotating section */}
        <VibemateUSP />

        <PropertyListings selectedCity={selectedCity} onClearCity={() => setSelectedCity(null)} />
        <Testimonials />
        <Footer />
      </div>

      <AIChatbot />
      {showPropertyMatch && <PropertyMatch onClose={() => setShowPropertyMatch(false)} />}
    </div>
  );
};

export default HomePage;